
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgEventHostDelete extends Vue {
    @Prop({type: Object, default: null}) private event!: any;
    @Prop({type: Object, default: null}) private host!: any;

    @Action('admin/events/removeHost') private deleteEventHost!: any;
    @Action('admin/events/readHosts') private readEventHosts!: any;
    @Getter('common/rules/all') private rules!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      await this.deleteEventHost({
        id: this.event.id,
        eventHostId: this.host.eventHostId,
      });
      await this.readEventHosts(this.event);
      this.dialog = false;
      this.loading = false;
    }
  }
